export enum FormErrors {
  general = 'general',
  network = 'network',
}

export type FormErrorsLocale = { [key in FormErrors]: string };

export const en: FormErrorsLocale = {
  general: 'Request failed',
  network: 'Network error',
};

export const cz: FormErrorsLocale = {
  general: 'Odeslání selhalo',
  network: 'Chyba sítě',
};



// WEBPACK FOOTER //
// /www/client/src/components/Form/formErrors.locale.ts